import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import PatientAppLayout from "../../components/PatientAppLayout/PatientAppLayout";
import { usePlatformSettingsPublic } from "../../hooks/usePlatformSettingsPublic";
import "./PatientProfileSubpages.scss";

const CONFIG = {
  terms: { title: "Terms & conditions", field: "termsHtml", versionKey: "terms" },
  privacy: { title: "Privacy policy", field: "privacyHtml", versionKey: "privacy" },
  cookies: { title: "Cookie policy", field: "cookiePolicyHtml", versionKey: null },
};

/**
 * @param {{ kind: 'terms' | 'privacy' | 'cookies' }} props
 */
export default function PatientProfileLegalDocPage({ kind }) {
  const cfg = CONFIG[kind] || CONFIG.terms;
  const { data, loading, error } = usePlatformSettingsPublic();

  const html = useMemo(() => {
    const raw = data?.legal?.[cfg.field];
    return typeof raw === "string" ? raw.trim() : "";
  }, [data, cfg.field]);

  const versionNote = useMemo(() => {
    if (!cfg.versionKey) return "";
    const v = data?.legalVersions?.[cfg.versionKey];
    return v ? String(v).trim() : "";
  }, [data, cfg.versionKey]);

  return (
    <PatientAppLayout activeNav="profile">
      <div className="patient-profile-sub patient-profile-sub--legalDoc">
        <article className="patient-profile-sub__card" aria-labelledby="legal-doc-title">
          <h1 id="legal-doc-title" className="patient-profile-sub__h1">
            {cfg.title}
          </h1>
          {versionNote ? (
            <p className="patient-profile-sub__meta">Document version {versionNote}</p>
          ) : null}

          {loading ? (
            <p className="patient-profile-sub__loading" role="status">
              Loading…
            </p>
          ) : error ? (
            <p className="patient-profile-sub__error" role="alert">
              {error}
            </p>
          ) : html ? (
            <div
              className="patient-profile-sub__html"
              /* Admin-controlled HTML from platform settings */
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ) : (
            <div className="patient-profile-sub__empty">
              <p>No published text yet for this document. You can still read our consent overview.</p>
              <Link
                to="/ConsentPage"
                state={{ patientBack: { to: "/patient-profile", label: "Menu" } }}
                className="patient-profile-sub__linkBtn"
              >
                Open consent &amp; privacy
              </Link>
            </div>
          )}
        </article>
      </div>
    </PatientAppLayout>
  );
}
